import { Popover } from 'antd'
import styles from './Popover.module.less'
import { DataTestId } from 'src/constants/ui.constants'

export type PopoverCompProps = {
    children: React.ReactNode
    content?: React.ReactNode
    placement?: 'top' | 'bottom' | 'left' | 'right'
    style?: React.CSSProperties
    title?: React.ReactNode
}

const PopoverComp: React.FC<PopoverCompProps> = props => {
    const popoverContent = <div className={styles.popoverContent}>{props.content}</div>

    return (
        <div data-testid={DataTestId.Popover}>
            <Popover
                content={popoverContent}
                overlayInnerStyle={props.style}
                placement={props.placement ?? undefined}
                title={props.title}
            >
                {props.children}
            </Popover>
        </div>
    )
}

export default PopoverComp
